const SPECIAL_CHARACTERS = "!#$%&'()*+,-./:;<=>?@[]^_`{|}~\\"
const ALPHANUMERIC_REGEX = /^[A-Za-z0-9]*$/
const SINGLE_ALPHANUMERIC_REGEX = /^[A-Za-z0-9]$/

const bytesToBase64 = bytes => {
  let binary = ''
  bytes.forEach(byte => {
    binary += String.fromCharCode(byte)
  })
  return btoa(binary)
}

const base64ToBytes = base64 => {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

const sha256Base64 = async value => {
  const data = new TextEncoder().encode(value)
  const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', data)
  return bytesToBase64(new Uint8Array(hashBuffer))
}

export const encryptWithSecret = async (data, secret) => {
  if (!secret) {
    throw new Error('ENCRYPT_SECRET no configurado')
  }
  if (!globalThis.crypto?.subtle) {
    throw new Error('Web Crypto no disponible')
  }

  let cola = ''
  if (!ALPHANUMERIC_REGEX.test(data)) {
    let aux = data
    for (let i = 0; i < aux.length; i += 1) {
      const element = aux[i]
      if (!SINGLE_ALPHANUMERIC_REGEX.test(element)) {
        const num = SPECIAL_CHARACTERS.indexOf(element)
        if (num < 0) {
          throw new Error(`character ${element} not is acepted`)
        }
        cola = `${cola}@${i}`
        aux = aux.replace(element, '0')
        data = data.replace(element, num < 10 ? `0${num}` : `${num}`)
      }
    }
  }

  const character = 4 - (data.length % 4)
  const init = character.toString().repeat(character)
  const payload = init.concat(data)

  const iv = globalThis.crypto.getRandomValues(new Uint8Array(16))
  const keyBase64 = await sha256Base64(secret)
  const keyString = keyBase64.substring(0, 32)
  const keyBytes = new TextEncoder().encode(keyString)
  const cryptoKey = await globalThis.crypto.subtle.importKey(
    'raw',
    keyBytes,
    { name: 'AES-CTR' },
    false,
    ['encrypt']
  )
  const dataBytes = base64ToBytes(payload)
  const cipherBuffer = await globalThis.crypto.subtle.encrypt(
    { name: 'AES-CTR', counter: iv, length: 128 },
    cryptoKey,
    dataBytes
  )

  const cipherBytes = new Uint8Array(cipherBuffer)
  const resultBytes = new Uint8Array(iv.length + cipherBytes.length)
  resultBytes.set(iv)
  resultBytes.set(cipherBytes, iv.length)

  return `${bytesToBase64(resultBytes)}${cola}`
}
